import { render, staticRenderFns } from "./QuickOptionsCard.vue?vue&type=template&id=390dc22f&scoped=true&"
import script from "./QuickOptionsCard.vue?vue&type=script&lang=js&"
export * from "./QuickOptionsCard.vue?vue&type=script&lang=js&"
import style0 from "./QuickOptionsCard.vue?vue&type=style&index=0&id=390dc22f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390dc22f",
  null
  
)

export default component.exports